type Translate = (key: string, options?: Record<string, string | number>) => string;

export function compactStockCount(count: number | null | undefined): string {
  const value = Math.max(0, Number(count ?? 0));
  return value > 10 ? '10+' : String(value);
}

export function catalogSaleCountLabel(t: Translate, count: number | null | undefined): string {
  return t('stock.saleCount', { count: compactStockCount(count) });
}

export function catalogStockCountLabel(t: Translate, count: number | null | undefined): string {
  return t('stock.inStockCount', { count: compactStockCount(count) });
}

export function commonStockCountLabel(t: Translate, count: number | null | undefined): string {
  return t('common.inStockCount', { count: compactStockCount(count) });
}

export function homeSaleCountLabel(t: Translate, count: number | null | undefined): string {
  return t('home.tcg.saleCountDisplay', { count: compactStockCount(count) });
}
